import mitt from 'mitt';

const emitter = mitt();
export const EventBus = emitter;
export default {
    install(app) {
        app.config.globalProperties.$eventbus = emitter;
        window.EVENTBUS = emitter;
    }
};